import { PatientPharmacies } from "~/common/components/pharmacies";
import type { PatientInformation } from "~/patients/utils/types";
import { AccountAccess } from "./AccountAccess";
import { GovernmentIssuedID } from "./GovernmentIssuedID";
import { UserDetails } from "./UserDetails";

interface AccountProps {
  currentPatient: PatientInformation;
}

export const Account = ({ currentPatient }: AccountProps) => {
  return (
    <div className="flex w-full flex-col items-center gap-6 px-6 pb-6 md:gap-8">
      <AccountAccess currentPatient={currentPatient} />
      <UserDetails currentPatient={currentPatient} />
      <PatientPharmacies />
      <GovernmentIssuedID currentPatient={currentPatient} />
    </div>
  );
};
